/**
 * 模块: AnalysisTabsSection
 * 职责: 搜索查询绩效数据分析Tabs区域组件
 * 限制: <280行
 */

import React from 'react';
import { Card, Tabs } from 'antd';
import { KeywordTrendPivotTab } from '../tabs/KeywordTrendPivot';
import { PriceCVRInsightTab } from '../tabs/PriceCVRInsight';
import { AdvantageKeywordsTab, MarketOverviewTab, OpportunityKeywordsTab } from '../index';
import type {
  AdvantageKeywordsResult,
  MarketOverview,
  OpportunityKeywordsResult,
} from '../../../types';

interface AnalysisTabsSectionProps {
  periodsCount: number;
  selectedPeriodId: number | null;
  advantageData: AdvantageKeywordsResult | null;
  marketOverview: MarketOverview | null;
  opportunityData: OpportunityKeywordsResult | null;
  keywordPivotData: any;
  loading: boolean;
  onTabChange: (key: string) => void;
}

export const AnalysisTabsSection: React.FC<AnalysisTabsSectionProps> = ({
  periodsCount,
  selectedPeriodId,
  advantageData,
  marketOverview,
  opportunityData,
  keywordPivotData,
  loading,
  onTabChange,
}) => {
  return (
    <Card className="data-card" style={{ marginTop: 24 }}>
      <div className="card-header">
        <h3>数据分析（{periodsCount} 个周期）</h3>
      </div>

      <Tabs
        defaultActiveKey="sp-pivot"
        onChange={onTabChange}
        items={[
          {
            key: 'sp-pivot',
            label: '📊 关键词趋势透视',
            children: (
              <KeywordTrendPivotTab data={keywordPivotData} loading={loading} />
            ),
          },
          {
            key: 'sp-price-cvr',
            label: '💰 价格-转化率洞察',
            children: (
              <PriceCVRInsightTab periodId={selectedPeriodId} />
            ),
          },
          {
            key: 'sp-advantage',
            label: '优势关键词',
            children: (
              <AdvantageKeywordsTab data={advantageData} loading={loading} />
            ),
          },
          {
            key: 'sp-overview',
            label: '大盘概况',
            children: (
              <MarketOverviewTab data={marketOverview} loading={loading} />
            ),
          },
          {
            key: 'sp-opportunity',
            label: '机会词挖掘',
            children: (
              <OpportunityKeywordsTab data={opportunityData} loading={loading} />
            ),
          },
        ]}
      />
    </Card>
  );
};

